<template>
	<div class="cp-groupp">
        <figure class="cp-groupp-image">
            <NuxtLink :to="item.url_without_domain">
				<BaseUiImage loading="lazy" :data="item.main_image_thumbs?.['width300-height360']" default="/images/no-image-300.jpg" :title="item.main_image_title" :alt="item.main_image_description ? item.main_image_description : ''" />
			</NuxtLink>	
		</figure>

		<div class="cp-groupp-cnt">
            <h2 v-if="item.title" class="cp-groupp-title"><NuxtLink :to="item.url_without_domain">{{item.title}}</NuxtLink></h2>
			
            <CatalogSetWishlist :item="item" />

            <div v-if="item?.type == 'groupproduct' && item?.groupproducts_ids" class="cp-groupp-items-cnt">
                <ClientOnly>
                    <BaseCatalogProductsWidget :fetch="{id: item.groupproducts_ids.split(',').filter(id => id.trim() !== ''), limit: 20}" v-slot="{items: groupProducts}">
                        <div v-if="groupProducts?.length" class="cp-groupp-items-title"><BaseCmsLabel code="group_product_title" /></div>
                        <div v-if="groupProducts?.length" class="cp-groupp-items">
                            <div v-for="item in groupProducts" :key="item.id" class="cp-groupp-item">
                                <NuxtLink :to="item.url_without_domain">{{item.title}}</NuxtLink>											
                            </div>
                        </div>							
                    </BaseCatalogProductsWidget>
                </ClientOnly>
            </div>                

			<div class="cp-groupp-cnt-bottom">				                
                <div class="cp-groupp-price-cnt">
                    <div v-if="item?.price_custom && item.price_custom > 0" class="cp-groupp-price"><BaseUtilsFormatCurrency :price="item.price_custom" /></div>             
                    <div v-if="item?.price_custom < item.basic_price" class="cp-groupp-save"><BaseCmsLabel code="price_save_2" /> <BaseUtilsFormatCurrency :price="item.basic_price - item.price_custom" /></div>                   
                </div>

				<WebshopAddToCartContainer :item="item" mode="cp" />  
            </div>    
        </div>       
	</div>
</template>

<script setup>
	const props = defineProps(['item']);
</script>

<style lang="less" scoped>
    .cp-groupp{
        position: relative; display: flex; border: 1px solid #DFDFDF; width: calc(~'50% - 10px'); padding: 32px;
        @media (max-width: @t){padding: 20px;}
        @media (max-width: @m){width: calc(~'50% - -1px'); margin: -1px 0 0 -1px; padding: 0; flex-flow: column;}
    }
    .cp-groupp-image{
        flex: 1 1 280px; margin-right: 32px; max-width: 280px;
        @media (max-width: @t){margin-right: 20px;}
        @media (max-width: @m){margin-right: 0; flex: 0 0 auto;}
        :deep(img){display: block; max-width: 100%; width: auto; height: auto; max-height: 280px;}
    }

    .cp-groupp-cnt{
        flex: 1 1 312px; display: flex; flex-flow: column;
        @media (max-width: @m){padding: 10px 15px 15px; text-align: center;}
    }
    :deep(.cp-wishlist){
        @media (max-width: @m){right: 12px; top: 12px;}
    }
    .cp-groupp-title{
        font-size: 18px; line-height: 21px; padding: 6px 24px 0 0; font-weight: normal;
        @media (max-width: @tp){font-size: 14px; line-height: 17px;}
        @media (max-width: @m){padding: 0 0 8px;}
        a{color: var(--textColor);}
    }

	.cp-groupp-items-cnt{
        padding: 8px 0; flex: 1 1 auto;
        @media (max-width: @m){padding: 0;}
    }
	.cp-groupp-items-title{
        font-size: 16px; line-height: 21px; font-weight: bold; padding-bottom: 5px;
        @media (max-width: @tp){font-size: 12px; line-height: 16px; padding-bottom: 2px;}
    }
	.cp-groupp-item{
		font-size: 16px; line-height: 21px; font-weight: normal; margin-bottom: 8px;
		@media (max-width: @tp){font-size: 12px; line-height: 16px;}
        a{
            display: inline-block;
			@media (min-width: @h){
				&:hover{text-decoration: none;}
			}            
        }
	}

    .cp-groupp-cnt-bottom{
        display: flex; align-items: center; justify-content: space-between;
        @media (max-width: @t){display: block;}
    }
    .cp-groupp-price{
        font-size: 20px; line-height: 20px; padding: 0 0 2px; font-weight: normal;
        @media (max-width: @tp){font-size: 14px; line-height: 16px;}
    }
    .cp-groupp-save{
        font-size: 14px; line-height: 20px; font-weight: bold; color: var(--red);
        @media (max-width: @tp){font-size: 12px; line-height: 13px;}
    }

    :deep(.cp-qty-add){
        margin: 0; justify-content: flex-end; width: auto;
        @media (max-width: @t){justify-content: flex-start; margin-top: 12px;}
        @media (max-width: @m){justify-content: center;}
        .cp-btn-addtocart{
            width: 48px;
            @media (max-width: @m){width: 40px;}
            span{
                font-size: 0; display: block; width: 22px; height: 22px; padding: 0;
                @media (max-width: @m){width: 20px; height: 20px;}
            }
        }
    }
    
</style>
